//
//
//
//
//
//
//
//
//
//
//
//
//
//

// This component is only here to make sure the VanishingTimer component is never used
// server-side. Since we're dealing with dates, timers, and timezones, rendering it
// on the server would eventually break the hydration process, making the whole
// application either crash or completely reload. In both case, it's far
// from good. So, this component wraps the VanishingTimer inside a
// ClientOnly instance to make sure it's always used that way.

import VanishingTimer from './VanishingTimer'

export default {
  components: {
    VanishingTimer,
  },

  inheritAttrs: false,
}
